import FullStar from "public/assets/full-review-star.svg"
import HalfStar from "public/assets/half-review-star.svg"
import { nanoid } from "nanoid"

export default function Stars({ blok: { rating }, starWidth = 32 }) {
  let testArray = Array(Math.ceil(rating)).fill("full")
  if (Math.ceil(rating) % rating !== 0) {
    testArray.fill("half", Math.floor(rating))
  }

  return (
    <div className="star-rating pb-4 flex gap-2">
      {testArray.map((star) =>
        star === "full" ? (
          <FullStar key={`star-rating-${rating}-${nanoid()}`} className="star" width={starWidth} />
        ) : (
          <HalfStar key={`star-rating-${rating}-${nanoid()}`} className="star" width={starWidth} />
        ),
      )}
    </div>
  )
}
